import { render, staticRenderFns } from "./JourneyViewer.vue?vue&type=template&id=2fa3b2ee&scoped=true"
import script from "./JourneyViewer.vue?vue&type=script&lang=js"
export * from "./JourneyViewer.vue?vue&type=script&lang=js"
import style0 from "./JourneyViewer.vue?vue&type=style&index=0&id=2fa3b2ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa3b2ee",
  null
  
)

export default component.exports